import { axiosInstance } from "./axios-instance"
import * as endpoints from "./../constants/api-constants"

class RegisterService {
  static preRegister(payload) {
    return axiosInstance
      .post(endpoints.preRegisterUser, payload)
      .then(resp => resp.data)
  }
  static dataParent(payload) {
    return axiosInstance
      .get(endpoints.preRegisterUser + payload)
      .then(resp => resp.data)
  }
  static register(payload) {
    return axiosInstance
      .put(endpoints.registerUser, payload)
      .then(resp => resp.data)
  }
  static codeVerificationRegister(payload) {
    return axiosInstance
      .post(endpoints.confirmUserCode, payload)
      .then(resp => resp.data)
  }
  static codeVerificationResend(payload) {
    return axiosInstance
      .post(endpoints.resendCode, payload)
      .then(resp => resp.data)
  }
  static parentConfirmation(payload) {
    return axiosInstance
      .post(endpoints.parentConfirmation, payload)
      .then(resp => resp.data)
  }
  static parentResentConfirmation(payload) {
    return axiosInstance
      .post(endpoints.parentResentConfirmation + payload)
      .then(resp => resp.data)
  }
  static validateNickname(payload) {
    return axiosInstance
      .get(endpoints.validateNickName + payload, {
        headers: {
          "x-api-key": process.env.ENVIRONMENT === 'PDN' ? process.env.X_API_KEY : process.env.X_API_KEY_DEV,
          "Device-Id": "Device-Id",
        },
      })
      .then(resp => resp.data)
  }

  static checkEmail(data) {
		return axiosInstance
			.post(endpoints.registerEmail, data)
			.then(resp => resp.data)
	}

  static checkPhone(data) {
		return axiosInstance
			.post(endpoints.registerCellPhone, data)
			.then(resp => resp.data)
	}
}

export default RegisterService
